import React, { useState, useCallback, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import {
  Box,
  Card,
  CardHeader,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Link,
  Tab,
  Typography,
  InputBase,
  LinearProgress,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { TabContext, TabList } from "@material-ui/lab";
import { utils, writeFileXLSX } from "xlsx";

import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  KeyboardBackspace as KeyboardBackspaceIcon,
  LocalShipping as LocalShippingIcon,
  FindInPage as FindInPageIcon,
  FileCopy as FileCopyIcon,
  Search as SearchIcon,
  GetApp as GetAppIcon,
  ArrowForward,
} from "@material-ui/icons";

import PrintButton from "components/_refactor/button/print";
import componentStyles from "assets/theme/views/admin/react-bs-table";
import componentStylesNotification from "assets/theme/components/dropdowns/notifications-dropdown.js";
import componentNavbarStyles from "assets/theme/components/navbars/admin-navbar.js";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import OccurencesDialog from "components/Dialogs/OccurencesDialog";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import Snackbar from "components/Alerts/Snackbar";
import UtilsFncs from "utils/UtilsFncs";
import useLogs from "hooks/logs";

import {
  sortableField,
  columnDateField,
  columnPriceField,
  columnNumberField,
  columnBooleanField,
  columnTextField,
} from "utils/tables-utils";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { IsMobile, IsMobile500 } from "utils/is-mobile";
import InvoicingRulesDisplay from "components/InvoicingRules/InvoicingRulesDisplay";

const useNavbarStyles = makeStyles(componentNavbarStyles);
const useStylesNotification = makeStyles(componentStylesNotification);

const useStyles = makeStyles({
  ...componentStyles,
  subTabsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "RGBA(255, 193, 197, 0.2)",
    width: "100%",
    borderRadius: ".375rem",
  },
  tab: {
    maxWidth: "max-content",
  },
  back: {
    left: 0,
    marginLeft: 30,
    color: "#493C43",
    fontWeight: 600,
    fontSize: 14,
  },
  table: {
    overflow: "auto",
  },
});

const exportIconStyle = {
  width: 25,
  height: 25,
  marginLeft: 15,
};

const TabelaPedidos = ({ dataTable, hideFilters }) => {
  const classes = {
    ...useStyles(),
    ...useNavbarStyles(),
    ...useStylesNotification(),
  };
  const componentRef = useRef(null);
  const { setLocalStorageApiProblem, setLocalStorageActions } = useLogs();

  const searchRef = useRef(null);
  const searchInputRef = useRef(null);

  const [valueSubTabPedidos, setValueSubTabPedidos] = useState("1");
  const [labelTableDetail, setLabeTablelDetail] = useState("Itens");
  const [modelTableDetail, setModelTableDetail] = useState(null);
  const [dataTableDetail, setDataTableDetail] = useState(null);
  const [keyFieldTableDetail, setKeyFieldTableDetail] = useState(null);
  const [modelTableItemDetail, setModelTableItemDetail] = useState(null);
  const [dataTableItemDetail, setDataTableItemDetail] = useState(null);
  const [keyFieldTableItemDetail, setKeyFieldTableItemDetail] = useState(null);
  const [ocorrenciasNF, setOcorrenciasNF] = useState(null);
  const [msgErro, setMsgErro] = useState("");
  const [msgInfo, setMsgInfo] = useState("");
  const [consultaPedidoDetail, setConsultaPedidoDetail] = useState(null);

  const [loadingRow, setLoadingRow] = useState(null);
  const [listDetails, setListDetails] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [fullDataTable, setFullDataTable] = useState([]);
  const [searchItemsList, setSearchItemsList] = useState(null);
  const [searchingItems, setSearchingItems] = useState(false);

  const snackbar = useSnackbar();

  const isMobile = IsMobile();
  const isMobile500 = IsMobile500();

  const styleBackButton = isMobile500
    ? {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "flex-start",
        marginTop: "1rem",
      }
    : { display: "flex", alignItems: "center" };

  const getFileInvoice = async (tipo, chave) => {
    return await Api.get(tipo, "invoice", "?chaveNf=" + chave, false)
      .then((value) => {
        const url =
          "data:application/octet-stream;base64," + value.Result.FileBase64;
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.target = "_blank";
        downloadLink.download = chave + "." + tipo;
        downloadLink.click();
      })
      .catch((error) => {
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "144",
          screen: "Consulta de Pedidos",
          problem: `Erro na chamada do endpoint de consulta de chaveNf - ${error}`,
        });
      });
  };

  const fotoProdutoItem = (cell, row) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          className={classes.img}
          alt="Imagem do item do pedido"
          src={row.UrlFoto}
          width={64}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.IdProduto}`}
        />
      </div>
    );
  };

  const OpenOccurrencesIcon = (cell, row) => {
    setLocalStorageActions({
      nomeTela: "Consulta de Pedidos",
      idMenu: "144",
      acao: "Clicou em Ver Ocorrências",
    });

    const fetchData = async () => {
      await Api.get(
        "tracking-occurrences",
        "sellinorder",
        "?chaveNF=" + row.ChaveNf,
        true
      )
        .then((value) => {
          if (
            value?.ErrorMessage ===
            "HTTPERRO 422 Não foi possível encontrar ocorrências de entrega. Verifique os parâmetros informados."
          ) {
            setMsgInfo(
              "Não foi possível encontrar ocorrências de entrega para essa nota."
            );
          } else if (!value || value.Result?.Ocorrencias.length === 0) {
            setMsgInfo(
              "Não foram encontradas ocorrências de entrega para essa nota."
            );
          } else {
            setOcorrenciasNF({ ...row, ...value.Result });
          }
        })
        .catch((error) => {
          setMsgErro(
            "Ocorreu um erro ao buscar por ocorrências de entrega para essa nota."
          );
          console.log(error);
          setLocalStorageApiProblem({
            idMenuAccess: "144",
            screen: "Consulta de Pedidos",
            problem: `Erro na chamada do endpoint  tracking-occurrences - ${error}`,
          });
        });
    };

    return row.ChaveNf !== null && row.ChaveNf > "" ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButtonLoader
          title="Ver Ocorrências de Entrega da Nota"
          className={classes.margin}
          size="small"
          extraStyle={{ padding: "0px", width: 22, height: 22 }}
          onClick={fetchData}
          icon={<LocalShippingIcon />}
        />
      </div>
    ) : null;
  };

  const urlConsultaSefaz = useCallback(
    (cell, row) => {
      return (
        <div>
          {row.ChaveNf !== null && row.ChaveNf > "" ? (
            <IconButton
              title="Consultar Sefaz"
              className={classes.margin}
              size="large"
              href={
                "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&nfe=" +
                row.ChaveNf
              }
              target="_blank"
              onClick={() => {
                setLocalStorageActions({
                  nomeTela: "Consulta de Pedidos",
                  idMenu: "144",
                  acao: "Clicou em Consultar Sefaz",
                });
              }}
            >
              <FindInPageIcon
                fontSize="large"
                style={{ padding: "0px", width: 22, height: 22 }}
              />
            </IconButton>
          ) : (
            ""
          )}
        </div>
      );
    },
    [classes.margin]
  );

  const truncarChaveNF = useCallback((cell, row) => {
    return row.ChaveNf !== null && row.ChaveNf > "" ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButtonLoader
          title="Copiar Chave NF"
          className={classes.margin}
          size="small"
          extraStyle={{ padding: "0px", width: 19, height: 19 }}
          onClick={() => {
            UtilsFncs.CopyToClipboard(row.ChaveNf);
            setLocalStorageActions({
              nomeTela: "Consulta de Pedidos",
              idMenu: "144",
              acao: "Clicou em Copiar Chave NF",
            });
          }}
          icon={<FileCopyIcon />}
        />
      </div>
    ) : null;
  }, []);

  const handleSearchDetails = (row) => {
    setLoadingRow(row.NumeroPedido);
    setListDetails(null);

    return Api.get(
      "list-orders-store",
      "sellinorder",
      "?numeroPedido=" + row.NumeroPedido,
      true
    )
      .then((res) => {
        if (
          res?.Result?.ListPedidos?.length === 0 ||
          res?.Result?.ListPedidos === null ||
          res?.Result?.ListPedidos === undefined
        ) {
          snackbar.showMessage(
            "Itens indisponíveis para consulta no momento.",
            {
              severity: "error",
            }
          );
        } else {
          setListDetails(res?.Result?.ListPedidos);
        }
      })
      .catch((error) => {
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "144",
          screen: "Consulta de Pedidos",
          problem: `Erro na chamada do endpoint list-orders-store - ${error}`,
        });
      })
      .finally(() => {
        setLoadingRow(null);
      });
  };

  const downloadXMLFile = React.useCallback(
    (cell, row) => {
      return row.XmlNoS3 ? (
        <div>
          <IconButtonLoader
            title="Download XML"
            size="small"
            onClick={(e) => {
              getFileInvoice("xml", row.ChaveNf, e);
              setLocalStorageActions({
                nomeTela: "Consulta de Pedidos",
                idMenu: "144",
                acao: "Clicou em Download XML",
              });
            }}
            icon={<GetAppIcon id={"downXML" + row.ChaveNf} fontSize="large" />}
          />
        </div>
      ) : null;
    },
    [classes.margin]
  );

  const downloadPDFFile = React.useCallback(
    (cell, row) => {
      return row.PdfNoS3 ? (
        <div>
          <IconButtonLoader
            title="Download PDF"
            size="small"
            onClick={(e) => {
              getFileInvoice("pdf", row.ChaveNf, e);
              setLocalStorageActions({
                nomeTela: "Consulta de Pedidos",
                idMenu: "144",
                acao: "Clicou em Download PDF",
              });
            }}
            icon={<GetAppIcon id={"downPDF" + row.ChaveNf} fontSize="large" />}
          />
        </div>
      ) : null;
    },
    [classes.margin]
  );

  const expandRowDetails = {
    renderer: (row) => (
      <Grid item xs={4}>
        {/* <Card> */}
        <ToolkitProvider
          data={dataTableItemDetail.filter(
            (x) => x.IdProduto === row.IdProduto
          )}
          keyField={keyFieldTableItemDetail}
          columns={modelTableItemDetail}
        >
          {(props) => (
            <div>
              <BootstrapTable
                classes={classes.table}
                ref={componentRef}
                {...props.baseProps}
                bootstrap4={true}
                bordered={false}
                condensed={true}
                striped={true}
                hover={true}
              />
            </div>
          )}
        </ToolkitProvider>
        {/* </Card> */}
      </Grid>
    ),
    showExpandColumn: labelTableDetail === "Itens",
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ExpandLessIcon />;
      }
      return <ExpandMoreIcon />;
    },
  };

  const handleClickMoreDetails = (details, tipoTabela) => {
    if (tipoTabela === 1) {
      //Itens
      setLabeTablelDetail("Itens");
      setModelTableDetail([
        {
          dataField: "UrlFoto",
          headerAlign: "center",
          align: "center",
          text: "",
          sort: false,
          formatter: fotoProdutoItem,
          csvExport: false,
        },
        sortableField({
          dataField: "SequencialItem",
          text: "Sequencial Item",
          align: "center",
        }),
        sortableField({
          dataField: "SituacaoItemPedido",
          text: "Situação Item Pedido",
          align: "center",
        }),
        sortableField({
          dataField: "LinhaProduto",
          text: "Linha Produto",
        }),
        sortableField({
          dataField: "ColecaoProduto",
          text: "Coleção Produto",
        }),
        columnNumberField(
          {
            dataField: "IdProduto",
            text: "Id Produto",
            align: "center",
          },
          true
        ),
        sortableField({
          dataField: "DescricaoProduto",
          text: "Descrição Produto",
        }),
        sortableField({
          dataField: "NomeProduto",
          text: "Nome Produto",
        }),
        columnNumberField(
          {
            dataField: "CodCorProduto",
            text: "Cod Cor Produto",
          },
          true
        ),
        sortableField({
          dataField: "TamanhoProduto",
          text: "Tamanho Produto",
        }),
        columnNumberField(
          {
            dataField: "QtdPedida",
            text: "Qtd Pedida",
            align: "right",
          },
          true
        ),
        columnNumberField(
          {
            dataField: "QtdAlocada",
            text: "Qtd Alocada",
            align: "right",
          },
          true
        ),
        columnNumberField(
          {
            dataField: "QtdFaturada",
            text: "Qtd Faturada",
            align: "right",
          },
          true
        ),
        columnNumberField(
          {
            dataField: "QtdEntregue",
            text: "Qtd Entregue",
            align: "right",
          },
          true
        ),
        columnPriceField(
          {
            dataField: "ValorProdutosDoItem",
            text: "Valor Produtos Do Item",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataEntregaDesejadaLojista",
            text: "Data Entrega Desejada Lojista",
            hidden: true,
            csvExport: true,
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataPrevistaOd",
            text: "Data Prevista Od",
            hidden: true,
            csvExport: true,
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataPrevistaFaturamento",
            text: "Data Prevista Faturamento",
            hidden: true,
            csvExport: true,
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataEntrega",
            text: "Data Entrega",
            hidden: true,
            csvExport: true,
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataPrevistaEstoque",
            text: "Data Prevista Estoque",
          },
          true
        ),
        sortableField({
          dataField: "Observacao",
          text: "Observação",
        }),
        sortableField({
          dataField: "CodOcLojista",
          text: "OC Lojista",
          align: "center",
        }),
      ]);
      setDataTableDetail(details[0]?.Itens);
      setKeyFieldTableDetail("SequencialItem");

      setModelTableItemDetail([
        columnNumberField(
          {
            dataField: "NumeroOd",
            text: "OD",
            sort: true,
          },
          true
        ),
        columnNumberField(
          {
            dataField: "NumeroNf",
            text: "Nr. NF",
          },
          true
        ),
        sortableField({
          dataField: "SerieNf",
          text: "Serie NF",
          headerAlign: "center",
          align: "center",
        }),
        columnNumberField(
          {
            dataField: "QtdFaturada",
            text: "Qtd. Faturada",
            align: "right",
          },
          true
        ),
        columnPriceField(
          {
            dataField: "PrecoUnitario",
            text: "Vlr. Unitário",
          },
          true
        ),
        columnPriceField(
          {
            dataField: "ValorLiquidoItemNf",
            text: "Vlr. Liq. NF",
          },
          true
        ),
        columnBooleanField(
          {
            dataField: "Entregue",
            text: "Entregue",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataPrevisaoEntrega",
            text: "Data Previsão Entrega",
          },
          true
        ),
        {
          dataField: "verOcorrencias",
          isDummyField: true,
          text: "Rastreio",
          headerAlign: "center",
          align: "center",
          sort: false,
          formatter: (cell, row) =>
            row?.DataPrevisaoEntrega !== "" && row?.DataPrevisaoEntrega ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButtonLoader
                  title="Ver Ocorrências de Entrega da Nota"
                  className={classes.margin}
                  size="small"
                  onClick={() => OpenOccurrencesIcon(row)}
                  icon={<LocalShippingIcon />}
                />
              </div>
            ) : null,
          csvExport: false,
        },
      ]);
      setDataTableItemDetail(details[0]?.OdProdutos);
      setKeyFieldTableItemDetail("IdProduto");
    } else if (tipoTabela === 2) {
      //NFs
      setLabeTablelDetail("NFs");
      setModelTableDetail([
        columnNumberField(
          {
            dataField: "NumeroNf",
            text: "Nr NF",
          },
          true
        ),
        sortableField({
          dataField: "SerieNf",
          text: "Serie NF",
          headerAlign: "center",
          align: "center",
        }),
        columnDateField(
          {
            dataField: "DataEmissaoNf",
            text: "Data Emissão NF",
          },
          true
        ),
        sortableField({
          dataField: "StatusNf",
          text: "Status NF",
        }),
        columnPriceField(
          {
            dataField: "ValorTotalNf",
            text: "Valor Total NF",
          },
          true
        ),
        {
          dataField: "ChaveNf",
          text: "Chave da NF",
          isDummyField: true,
          align: "center",
          headerAlign: "center",
          formatter: truncarChaveNF,
          sort: false,
        },
        columnBooleanField(
          {
            dataField: "Entregue",
            text: "Entregue",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataPrevisaoEntrega",
            text: "Data Previsão Entrega",
          },
          true
        ),
        {
          dataField: "verOcorrencias",
          isDummyField: true,
          text: "Rastreio",
          align: "center",
          headerAlign: "center",
          sort: false,
          formatter: (cell, row) =>
            row?.DataPrevisaoEntrega !== "" && row?.DataPrevisaoEntrega ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconButtonLoader
                  title="Ver Ocorrências de Entrega da Nota"
                  className={classes.margin}
                  size="small"
                  onClick={() => OpenOccurrencesIcon(row)}
                  icon={<LocalShippingIcon />}
                />
              </div>
            ) : null,
          csvExport: false,
        },
        {
          dataField: "consulta",
          text: "Consulta Sefaz",
          isDummyField: true,
          align: "center",
          headerAlign: "center",
          formatter: urlConsultaSefaz,
          csvExport: false,
        },
        {
          dataField: "XmlNoS3",
          text: "XML",
          isDummyField: true,
          align: "center",
          headerAlign: "center",
          formatter: downloadXMLFile,
          csvExport: false,
        },
        {
          dataField: "PdfNoS3",
          text: "PDF",
          isDummyField: true,
          align: "center",
          headerAlign: "center",
          formatter: downloadPDFFile,
          csvExport: false,
        },
      ]);
      setDataTableDetail(details[0]?.NFs);
      setKeyFieldTableDetail("NumeroNf");
    } //ODs
    else if (tipoTabela === 3) {
      setLabeTablelDetail("ODs");
      setModelTableDetail([
        columnNumberField(
          {
            dataField: "NumeroOd",
            text: "Nr OD",
          },
          true
        ),
        columnPriceField(
          {
            dataField: "VlrOd",
            text: "Valor OD",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataGeracaoOd",
            text: "Data Geração",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataEmissaoOd",
            text: "Data Emissão",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataComplementoExpedicao",
            text: "Data Complemento Expedição",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataComplementoExportacao",
            text: "Data Complemento Exportação",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataComplementoFaturamento",
            text: "Data Complemento Faturamento",
          },
          true
        ),
        sortableField({
          dataField: "Situacao",
          text: "Situação",
          align: "center",
        }),
        columnDateField(
          {
            dataField: "DataEmbarque",
            text: "Data Embarque",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataInicioFaturamento",
            text: "Data Inicio Faturamento",
          },
          true
        ),
        columnDateField(
          {
            dataField: "DataLimiteFaturamento",
            text: "Data Limite Faturamento",
          },
          true
        ),
        columnTextField(
          {
            dataField: "NomeTransportadoraDespacho",
            text: "Nome Transportadora Despacho",
          },
          true
        ),
        columnTextField(
          {
            dataField: "NomeTransportadoraRedespacho",
            text: "Nome Transportadora Redespacho",
          },
          true
        ),
      ]);
      setDataTableDetail(details[0]?.ODs);
      setKeyFieldTableDetail("NumeroOd");
    } else {
      setLabeTablelDetail("Regras de Faturamento");
    }
  };

  const getConsultaPedidoDetail = async (row) => {
    try {
      const response = await Api.get(
        "consulta-pedido-detail",
        "reportApp",
        `?numeroPedido=${encodeURIComponent(row.NumeroPedido)}`,
        true
      );
      if (response?.Success === false && response?.ValidationMessage) {
        snackbar.showMessage(response.ValidationMessage, { severity: "warning" });
        setConsultaPedidoDetail(null);
        return;
      }
      setConsultaPedidoDetail(response?.Result ?? null);
    } catch (error) {
      const msg =
        typeof error === "string"
          ? error
          : error?.message || "Erro ao buscar regras do pedido no Ciclo";
      snackbar.showMessage(msg, { severity: "error" });
      setConsultaPedidoDetail(null);
    }
  };

  const columnModel = [
    columnTextField(
      {
        dataField: "CnpjLojista",
        text: "CNPJ",
        formatter: (params) => {
          return MaskAndValid.maskCPNJCPF(params);
        },
      },
      true
    ),
    columnNumberField(
      {
        dataField: "NumeroPedido",
        text: "Nr Pedido",
      },
      false
    ),
    columnNumberField(
      {
        dataField: "NumeroProposta",
        text: "Nr Proposta",
      },
      false
    ),
    columnTextField(
      {
        dataField: "ParcialmenteFaturado",
        text: "Parcialmente Faturado",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "StatusPedido",
        text: "Status",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataPedidoFormat",
        text: "Data do Pedido",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataUltimaConfirmacaoFormat",
        text: "Última Confirmação",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataPrazoEntregaFormat",
        text: "Prazo de Entrega",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "NomeRepresentante",
        text: "Nome Representante",
        align: "center",
      },
      false
    ),
    columnPriceField(
      {
        dataField: "ValorFaturado",
        text: "Valor Faturado",
      },
      true
    ),
    columnPriceField(
      {
        dataField: "ValorSaldoEmAberto",
        text: "Valor Saldo Em Aberto",
      },
      true
    ),
    columnTextField(
      {
        dataField: "Marca",
        text: "Marca",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "NomeCondicaoPgto",
        text: "Condicao Pgto",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataPrevisaoFaturamentoFormat",
        text: "Previsão Faturamento",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "Pendencias",
        text: "Pendências",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "GrupoEconomico",
        text: "Grupo Econômico",
      },
      false
    ),
    columnTextField(
      {
        dataField: "RazaoSocial",
        text: "Razão Social",
      },
      false
    ),
    columnTextField(
      {
        dataField: "Apelido",
        text: "Loja",
      },
      false
    ),
    columnNumberField(
      {
        dataField: "CodTabelaPreco",
        text: "Tabela de Preço",
      },
      false
    ),
    columnTextField(
      {
        dataField: "CCLoja",
        text: "CC Loja",
        align: "center",
        headerAlign: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "NomeCcSupervisor",
        text: "Nome Cc Supervisor",
        align: "left",
      },
      false
    ),
    {
      dataField: "",
      text: "Detalhes",
      isDummyField: true,
      align: "center",
      formatter: (cell, row) => {
        return (
          <div key={String(loadingRow)}>
            {loadingRow === row.NumeroPedido ? (
              <CircularProgress style={exportIconStyle} />
            ) : (
              <div
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleSearchDetails(row);
                  getConsultaPedidoDetail(row);
                }}
              >
                <ArrowForward fontSize="large" />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const handleChangeSubTabPedidos = (event, newValue) => {
    setValueSubTabPedidos(newValue);
    if (newValue === "1") {
      handleClickMoreDetails(listDetails, 1);
    } else if (newValue === "2") {
      handleClickMoreDetails(listDetails, 2);
    } else if (newValue === "3") {
      handleClickMoreDetails(listDetails, 3);
    } else {
      return;
    }
  };

  function handleDownloadXML() {
    let receipt = "";
    if (searchItemsList?.length !== 0 && searchItemsList !== null) {
      receipt = utils.json_to_sheet(searchItemsList);
    } else {
      receipt = utils.json_to_sheet(fullDataTable);
    }

    const wb = utils.book_new();
    utils.book_append_sheet(wb, receipt, "Pedidos");
    writeFileXLSX(wb, "Pedidos.xlsx");
  }

  const exportCmp =
    searchItemsList?.length !== 0 && searchItemsList !== null ? (
      <>
        <span>
          <Tooltip title="Exportar tudo">
            <IconButtonLoader
              onClick={() => handleDownloadXML()}
              icon={
                <img
                  src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                  alt="ícone clicável para exportar a tabela no formato Excel"
                  style={exportIconStyle}
                />
              }
              size="small"
            />
          </Tooltip>
        </span>
      </>
    ) : (
      <>
        {fullDataTable?.length !== 0 ? (
          <>
            <span>
              <Tooltip title="Exportar tudo">
                <IconButtonLoader
                  onClick={() => handleDownloadXML()}
                  icon={
                    <img
                      src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                      alt="ícone clicável para exportar a tabela no formato Excel"
                      style={exportIconStyle}
                    />
                  }
                  size="small"
                />
              </Tooltip>
            </span>
          </>
        ) : null}
      </>
    );

  const handleClick = () => {
    if (searchValue !== "") {
      setSearchingItems(true);
      const listItens = [];
      fullDataTable?.map((item) => {
        if (
          item?.GrupoEconomico?.includes(searchValue?.toUpperCase()) ||
          item?.NomeRepresentante?.includes(searchValue?.toUpperCase()) ||
          item?.RazaoSocial?.includes(searchValue?.toUpperCase()) ||
          item?.Apelido?.includes(searchValue?.toUpperCase()) ||
          item?.CnpjLojista?.includes(searchValue) ||
          item?.NumeroPedido?.toString()?.includes(searchValue?.toString()) ||
          item?.NumeroProposta?.includes(searchValue?.toUpperCase()) ||
          item?.ParcialmenteFaturado?.includes(searchValue) ||
          item?.StatusPedido?.includes(searchValue) ||
          item?.DataPedidoFormat?.includes(searchValue) ||
          item?.DataUltimaConfirmacaoFormat?.includes(searchValue) ||
          item?.DataPrazoEntregaFormat?.includes(searchValue) ||
          item?.ValorFaturadoFormat?.includes(searchValue) ||
          item?.ValorSaldoEmAbertoFormat?.includes(searchValue) ||
          item?.Marca?.includes(searchValue) ||
          item?.NomeCondicaoPgto?.includes(searchValue) ||
          item?.DataPrevisaoFaturamentoFormat?.includes(searchValue) ||
          item?.Pendencias?.includes(searchValue) ||
          item?.CodTabelaPreco?.toString()?.includes(searchValue?.toString()) ||
          item?.NomeCc?.includes(searchValue?.toUpperCase) ||
          item?.NomeCcSupervisor?.includes(searchValue?.toUpperCase)
        ) {
          listItens.push(item);
        }
      });
      setSearchItemsList(listItens);
      setTimeout(() => {
        setSearchingItems(false);
      }, 500);
    }
  };

  const handleValueChange = useCallback((e) => {
    if (e.target.value === "") {
      setSearchItemsList(null);
    }
    setSearchValue(e.target.value);
    searchInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (listDetails?.length !== 0 && listDetails !== null) {
      handleClickMoreDetails(listDetails, 1);
      if (hideFilters) {
        hideFilters(true);
      }
    }
  }, [listDetails]);

  useEffect(() => {
    setFullDataTable(dataTable);
  }, [dataTable]);

  useEffect(() => {
    if (searchItemsList?.length === 0) {
      setTimeout(() => {
        setSearchItemsList(null);
      }, 2500);
    }
  }, [searchItemsList]);

  return (
    <>
      {listDetails?.length !== 0 &&
      listDetails !== null &&
      modelTableDetail !== null ? (
        <>
          <Grid
            item
            xs={12}
            style={{ marginTop: 20, zIndex: 10, position: "relative" }}
          >
            <Card>
              <div
                className={classes.subTabsHeader}
                style={
                  isMobile500
                    ? { flexDirection: "column" }
                    : { flexDirection: "row" }
                }
              >
                <Link
                  className={classes.back}
                  color="textSecondary"
                  component="button"
                  variant="body2"
                  style={styleBackButton}
                  onClick={() => {
                    setListDetails(null);
                    setValueSubTabPedidos("1");
                    if (hideFilters) {
                      hideFilters(false);
                    }
                  }}
                >
                  <KeyboardBackspaceIcon style={{ marginRight: "0.25rem" }} />
                  VOLTAR
                </Link>
                <TabContext value={valueSubTabPedidos}>
                  <TabList
                    style={{ width: "85%" }}
                    onChange={handleChangeSubTabPedidos}
                    centered={isMobile500 ? true : false}
                    variant="scrollable"
                    scrollButtons="on"
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab
                      className={classes.tab}
                      label="Itens"
                      value="1"
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Consulta de Pedidos",
                          idMenu: "144",
                          acao: "Clicou na aba Itens",
                        });
                      }}
                    />
                    <Tab
                      className={classes.tab}
                      label="NFs"
                      value="2"
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Consulta de Pedidos",
                          idMenu: "144",
                          acao: "Clicou na aba NFs",
                        });
                      }}
                    />
                    <Tab
                      className={classes.tab}
                      label="ODs"
                      value="3"
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Consulta de Pedidos",
                          idMenu: "144",
                          acao: "Clicou na aba ODs",
                        });
                      }}
                    />
                    <Tab
                      className={classes.tab}
                      label="Regras de Fat."
                      value="4"
                      onClick={() => {
                        setLocalStorageActions({
                          nomeTela: "Consulta de Pedidos",
                          idMenu: "144",
                          acao: "Clicou na aba Regras de Fat. aba Pedidos",
                        });
                      }}
                    />
                  </TabList>
                </TabContext>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 15 }}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Grid container alignItems="center">
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Nr Pedido</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.NumeroPedido || <br />}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Nr Proposta</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.NumeroProposta || <br />}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Parcialmente Faturado</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.ParcialmenteFaturado || <br />}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Status</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.StatusPedido || <br />}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <FormGroup>
                          <FormLabel>Data do Pedido</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.DtPedido ? (
                              MaskAndValid.formattDateBR(
                                listDetails[0]?.DtPedido
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Valor Faturado</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.ValorFaturado ? (
                              MaskAndValid.maskPrice(
                                listDetails[0]?.ValorFaturado
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Data Entrega Desejada</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.Itens[0]
                              ?.DataEntregaDesejadaLojista ? (
                              MaskAndValid.formattDateBR(
                                listDetails[0]?.Itens[0]
                                  ?.DataEntregaDesejadaLojista
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Data Prevista Od</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.Itens[0]?.DataPrevistaOd ? (
                              MaskAndValid.formattDateBR(
                                listDetails[0]?.Itens[0]?.DataPrevistaOd
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={2}>
                        <FormGroup>
                          <FormLabel>Data Prevista Faturamento</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.Itens[0]
                              ?.DataPrevistaFaturamento ? (
                              MaskAndValid.formattDateBR(
                                listDetails[0]?.Itens[0]
                                  ?.DataPrevistaFaturamento
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <FormGroup>
                          <FormLabel>Data Entrega</FormLabel>
                          <Typography variant="body2">
                            {listDetails[0]?.Itens[0]?.DataEntrega ? (
                              MaskAndValid.formattDateBR(
                                listDetails[0]?.Itens[0]?.DataEntrega
                              )
                            ) : (
                              <br />
                            )}
                          </Typography>
                        </FormGroup>
                      </Grid>
                    </Grid>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
            </Card>
            {valueSubTabPedidos === "4" ? (
              <InvoicingRulesDisplay consultaPedidoDetail={consultaPedidoDetail} />
            ) : (
              <div>
                {listDetails !== null &&
                dataTableDetail !== null &&
                dataTableDetail.length !== 0 ? (
                  <ToolkitTable
                    keyField={keyFieldTableDetail}
                    allowEmpty
                    dataTable={dataTableDetail}
                    columnModel={modelTableDetail}
                    headerTitle={`${labelTableDetail} do Pedido ${
                      listDetails ? listDetails[0]?.NumeroPedido : ""
                    }`}
                    csvFileName={`${labelTableDetail}Pedido${listDetails[0]?.NumeroPedido}.csv`}
                    pagination={{
                      options: [25, 50, 100],
                      defaultOption: 25,
                    }}
                    bootstrapTableProps={{ expandRow: expandRowDetails }}
                    showPrint
                  />
                ) : (
                  <Card>
                    <Grid item style={{ padding: "1.25rem" }}>
                      <Typography variant="body2" component="p">
                        0 {labelTableDetail}
                      </Typography>
                    </Grid>
                  </Card>
                )}
              </div>
            )}
          </Grid>
        </>
      ) : (
        <>
          {searchingItems ? (
            <div style={{ marginTop: "1rem" }}>
              <span>Buscando dados..</span>
              <LinearProgress />
            </div>
          ) : (
            <ToolkitTable
              searched={Boolean(dataTable)}
              keyField="NumeroPedido"
              dataTable={searchItemsList ? searchItemsList : fullDataTable}
              columnModel={columnModel}
              pagination={{
                options: [25, 50, 100],
                defaultOption: 25,
                totalSize: searchItemsList
                  ? searchItemsList?.length
                  : fullDataTable?.length,
                showTotal: true,
              }}
              notFoundTitle="Sua pesquisa não encontrou nenhum pedido correspondente."
              CustomHeader={({ componentRefProps, selectRefProps }) => (
                <Grid
                  container
                  className="pl-4"
                  style={{ height: 60, padding: "0 24px 12px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: isMobile ? "flex-start" : "center",
                      marginBottom: isMobile ? "1rem" : 0,
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    <Box
                      component={Typography}
                      variant="h3"
                      marginBottom="0!important"
                    >
                      <Box component="span">Pedidos</Box>
                    </Box>
                    <Box
                      display="flex"
                      ref={searchRef}
                      alignItems="center"
                      width="auto"
                      component={Grid}
                      className={classes.searchBox}
                      style={{ marginLeft: isMobile ? 0 : "1rem" }}
                    >
                      <Tooltip title={"Pesquisar"}>
                        <SearchIcon
                          className={classes.searchIcon}
                          onClick={handleClick}
                          style={{ cursor: "pointer" }}
                          fontSize="large"
                        />
                      </Tooltip>
                      <InputBase
                        inputRef={searchInputRef}
                        placeholder="Faça a sua busca"
                        classes={{
                          input: classes.searchInput,
                        }}
                        value={searchValue}
                        onChange={handleValueChange}
                        autoComplete="off"
                        name="search"
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      padding: 0,
                      marginBottom: "0.5rem!important",
                    }}
                  >
                    <Box
                      justifyContent="flex-end"
                      alignItems="center"
                      display="flex"
                      flexWrap="wrap"
                      style={{
                        marginLeft: 15,
                        marginRight: 15,
                        cursor: "pointer",
                      }}
                    >
                      {exportCmp}
                    </Box>
                    <Box
                      justifyContent="flex-end"
                      alignItems="center"
                      display="flex"
                      flexWrap="wrap"
                      style={{
                        marginLeft: 15,
                        marginRight: 15,
                        cursor: "pointer",
                      }}
                    >
                      <PrintButton
                        selectRef={selectRefProps}
                        componentRef={componentRefProps}
                        dataTable={
                          searchItemsList ? searchItemsList : fullDataTable
                        }
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
            />
          )}
        </>
      )}
      <Snackbar
        text={msgErro}
        open={Boolean(msgErro)}
        autoHideDuration={6000}
        onClose={() => setMsgErro(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="error"
      />
      <Snackbar
        text={msgInfo}
        open={Boolean(msgInfo)}
        autoHideDuration={6000}
        onClose={() => setMsgInfo(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity="info"
        style={{ backgroundColor: "#5e72e4" }}
      />

      {ocorrenciasNF ? (
        <OccurencesDialog
          data={ocorrenciasNF}
          handleClose={() => setOcorrenciasNF(null)}
          dialogTitle={`Ocorrências de Entrega da Nota ${ocorrenciasNF.NumeroNf} - ${ocorrenciasNF.SerieNf}`}
        />
      ) : null}
    </>
  );
};

TabelaPedidos.propTypes = {
  dataTable: PropTypes.array,
};

export default TabelaPedidos;
